import { useState } from "react";
import { useForm } from "react-hook-form";
import { useMutation, useQueryClient } from "react-query";
import { FormPage } from "../../../common/components/form_page";
import { ButtonControl } from "../../../common/components/controls/button";
import { createUserAddress, patchUserAddress, patchUserProfile } from "../../../common/apis/private.api";
import { IUserAddresses, IUserInformation } from "../../../common/constants/app.dto";
import { textChooser } from "../../../common/util/textChooser";
import { useUser } from "../../../common/hooks/User";
import InformationFormContent from "./information-form-content";

interface InformationProps { }

interface InformationForm extends IUserInformation {
  addresses: Partial<IUserAddresses>
  id: string;
}

const initialGeoState = {
  address: "",
  city: "",
  district: "",
  location: "",
}

export const Information = (props: InformationProps) => {
  const client = useQueryClient()
  const userData = useUser().getDataAll();

  const { register, setValue, handleSubmit, control, formState: { errors } } = useForm<InformationForm>();

  const [geo, setGeo] = useState<any>({
    ...initialGeoState,
    ...userData.addresses[0],
  });

  const { mutate, isLoading, isError } = useMutation((params: any) =>
    handleInfoAndAddressCreation(params)
  );

  const handleOnSubmit = ({ addresses, ...information }: any) => {
    let secondaryStudy = false;
    if (information.secondaryStudy === 'true') {
      secondaryStudy = true
    }

    const salaryRange = parseInt(information.salaryRange)

    mutate({
      userAddress: addresses, userInfo: {
        ...information,
        email: userData.email,
        id: userData.id,
        secondaryStudy,
        salaryRange
      }
    });

    client.invalidateQueries(['validate-profile'])
  }

  const handleInfoAndAddressCreation = (params: any) => {
    const requestInfo = patchUserProfile(userData.id, params.userInfo);

    const requestAddrs = userData.addresses.length ?
      patchUserAddress(userData.id, userData.addresses[0].id, params.userAddress) :
      createUserAddress(userData.id, params.userAddress)

    return Promise.allSettled([requestInfo, requestAddrs]);
  }

  return (
    <FormPage pageTitle={textChooser("txt77")} className="personal-info">
      <form onSubmit={handleSubmit(handleOnSubmit)}>
        <InformationFormContent
          hasError={isError}
          register={register}
          setValue={setValue}
          setGeo={setGeo}
          geo={geo}
          errors={errors}
          userData={userData}
          control={control}
        />
        <div className="row">
          <div className="col-xs-12 col-md-5" style={{ marginTop: "15px" }}>
            <ButtonControl
              type="submit"
              value={isLoading ? textChooser("txt140") : textChooser("txt80")}
              disabled={isLoading}
              primary
            />
          </div>
        </div>
      </form>
    </FormPage>
  )
}